import React from 'react';
// template components
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// images
import highResDesktopImageWebp from './images/whole-life-insurance-hero.webp';
import highResMobileImageWebp from './images/whole-life-insurance-hero-mobile.webp';
// low res images
import { lowResImageDesktop, lowResImageMobile } from './lowResImages';
// styles
import { HeroSectionStyled } from './styles';

export default () => {
  return (
    <HeroSectionStyled
      sectionId='whole-life-insurance-hero'
      productName='whole life Insurance'
      headingText={<>Let&#39;s protect your <WidowBlock>&#40;whole&#41; life.</WidowBlock></>}
      descriptionText={<>Do more of the things you love&#8212;with those you love. Our industry&#45;leading coverage lasts your entire life and has many benefits you can use along the way.</>}
      ctaPrimary={{
        linkUrl: '/find-a-financial-advisor/',
        buttonText: 'Get insurance',
        ariaLabel: 'Get insurance with a financial professional.',
        children: '',
      }}
      backgroundImageAriaLabel='A mother and daughter laughing together in a kayak'
      backgroundImageDesktop={highResDesktopImageWebp.toString()}
      backgroundImageMobile={highResMobileImageWebp.toString()}
      backgroundImageDesktopLowRes={lowResImageDesktop}
      backgroundImageMobileLowRes={lowResImageMobile}
      backgroundVariant='lightB'
      themeType='lightTheme'
    />
  );
};
